
export default {
  name: "MainContent",

  fetch: async function () {
    await this.initFiltersMain();
  },

  data: function () {
    return {
      characteristicsMain: [],

      isLoadCharacteristicsMain: true
    }
  },

  props: {
    product: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  computed: {
    pageTitle: function () {
      let text = this.product?.dynamicFields?.seo_heading || this.product?.name || "";
      return text
    },

    characteristics: function () {
      const productCharacteristics = this.product?.characteristics || [];
      const mainCharacteristics = (this.product?.characteristics || []).find((t) => t.name === "Основное")?.characteristics || [];
      const additionalCharacteristics = (this.product?.characteristics || []).find((t) => t.name === "Дополнительные")?.characteristics || [];

      let characteristics = [
          ...mainCharacteristics,
          ...additionalCharacteristics
      ];
      characteristics = characteristics.filter((t) => t.showInProduct);
      characteristics = characteristics.map((char) => {
        const values = (char?.values || [])
          .sort((a, b) => {
            if (a.sort > b.sort) {
              return 1
            }
            if (a.sort < b.sort) {
              return -1
            }
            return 0
          });
        char.value = values.map((t) => {
          return [t?.value, char?.unit].filter((t) => !!t).join(" ");
        }).join(", ")
        return char
      });

      return characteristics
    },
    price: function () {
      if (!this.product.price) {
        return "По запросу"
      }

      return this.$numberFormat(this.product.price)
    },

    labelButtonOrder: function () {
      return "Оставить заявку"
      let label = ['Заказать перевозку'];

      if (this.product?.characteristicGroupId === 1) {
        const charSystem = (this.product?.characteristics || []).find((t) => (t.name === "Системные" || t.name === "Системная"))?.characteristics || [];
        const imyaRoditelnomPadezhe = charSystem.find((t) => t.slug === "imya-v-roditelnom-padezhe")?.values?.[0]?.value || "";
        label.push((imyaRoditelnomPadezhe || this.product?.name || "").toLocaleLowerCase());
      }
      if (this.product?.characteristicGroupId === 2) {
        const charSystem = (this.product?.characteristics || []).find((t) => (t.name === "Системные" || t.name === "Системная"))?.characteristics || [];
        const imyaTvoritelnomPadezhe = charSystem.find((t) => t.slug === "imya-v-tvoritelnom-padezhe")?.values?.[0]?.value || "";
        const imyaRoditelnomPadezhe = charSystem.find((t) => t.slug === "imya-v-roditelnom-padezhe")?.values?.[0]?.value || "";
        label.push((imyaTvoritelnomPadezhe || imyaRoditelnomPadezhe || this.product?.name || "").toLocaleLowerCase());
      }

      return label.join(" ");
    },


    productCharacteristicGroupId: function () {
      return this.product?.characteristicGroupId
    }
  },

  components: {
    MessageMore: () => import("~/components/UI/MessageMore.vue")
  },

  watch: {
    characteristics: async function () {
      await this.initFiltersMain();
    }
  },

  mounted: async function () {
    await this.initFiltersMain();
  },

  methods: {
    initFiltersMain: async function () {
      // if (this.product?.characteristicGroupId === 2) {
      //   return
      // }

      const fullCategories = this.$store.state?.catalog?.categories || [];

      const characteristics = ([...this.characteristics] || []);
      const characteristicsMain = await Promise.all(characteristics.map(async (filter) => {
        const valuesIds = (filter?.values || []).map((t) => t.id);
        const response = await this.$api.agent.transport.get(`char?variant_ids=${ valuesIds.join(",") }`).then((res) => {
          return res.data
        }).catch(() => {
          return {}
        });
        const values = filter.values
          .map((t) => {
          let urlPage = response?.[t.id]?.url;
          if (!urlPage) {
            const customUrlChar = `${filter.slug}/${t.slug}`;
            const findCategoryUrl = fullCategories.find((t) => Boolean((t.url || "").indexOf(customUrlChar) > -1));
            urlPage = findCategoryUrl?.url || "";
          }

          return {
            ...t,
            urlPage: urlPage
          }
        })
          .sort((a, b) => {
            if (a?.sort > b?.sort) {
              return 1
            }
            if (a?.sort < b?.sort) {
              return -1
            }
            return 0
          })
        return {
          ...filter,
          values
        }
      }));
      this.characteristicsMain = characteristicsMain;
      this.isLoadCharacteristicsMain = false;
    },

    onOrderTransportation: function () {
      this.$store.commit("back-call/setOpen", {
        open: true,
        settings: {
          title: this.labelButtonOrder,
          message: this.labelButtonOrder,

          miniReachGoal: 'zayavka_kartochka_small',
          fullReachGoal: 'zayavka_kartochka_big',
        }
      });
    },
    openFullImage: function () {
      this.$store.commit("pop-up-images/setOpen", {
        images: [this.product.imageId]
      })
    }
  }
}
